"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAnimationsSpeed = exports.SET_ANIMATIONS_SPEED = void 0;
exports.SET_ANIMATIONS_SPEED = 'SET_ANIMATIONS_SPEED';
function setAnimationsSpeed(speed) {
    return { type: exports.SET_ANIMATIONS_SPEED, speed: speed };
}
exports.setAnimationsSpeed = setAnimationsSpeed;
